module.exports = {
  latestClaimsDate: new Date('2025-12-31'),
};
